import {
  ALTERNATE,
  CLASSIC,
  REMAN,
  DEALERREMAN,
  DEALERALTERNATE
} from '../../../../../constants/productAssociation';

export const PART_TYPE = {
  REMAN: REMAN,
  CLASSIC: CLASSIC,
  ALTERNATE: ALTERNATE,
  DEALERREMAN: DEALERREMAN,
  DEALERALTERNATE: DEALERALTERNATE
};

export const COMMON_NOTES_REGEX = /[\\<>[\]{}&()]/;
export const ITEM_NUMBER_REGEX = /[!@#$%^&*+{};`~()]/;
